import React from 'react';
import Grid from '@sendgrid/style-guide-grid';
import { Checkbox } from '@sendgrid/ui-components';
import PropTypes from 'prop-types';
import withProfileInputs from '../containers/withProfileInputs';

export const EmailMethodForm = props => (
  <section className={Grid.row} data-role="email-method-container">
    <p
      className={`form-prompt ${Grid['col-12']}`}
      data-role="email-method-prompt"
    >
      How do you plan to send email?
    </p>
    <div className={Grid['col-6']}>
      <Checkbox
        id="checkbox-transactional"
        value="Transactional"
        data-role="checkbox-transactional"
        onChange={props.toggleIsTransactional}
      >
        Using our API
      </Checkbox>
    </div>
    <div className={Grid['col-6']}>
      <Checkbox
        id="checkbox-marketing"
        value="Marketing"
        data-role="checkbox-marketing"
        onChange={props.toggleIsMarketing}
      >
        Using Marketing Campaigns
      </Checkbox>
    </div>
  </section>
);

EmailMethodForm.propTypes = {
  toggleIsMarketing: PropTypes.func.isRequired,
  toggleIsTransactional: PropTypes.func.isRequired,
};
export default withProfileInputs(EmailMethodForm);



// WEBPACK FOOTER //
// ./src/components/EmailMethodForm.jsx